import aiCostsFiltersSignal, {
	setAiCostsFilters,
} from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import type AiCostFilterOptionsView from '@UI/Store/AiCosts/Views/AiCostFilterOptionsView';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type Props = { options: AiCostFilterOptionsView | null };

/** Lists the users of the chosen facility or structure, inactive ones included: their past costs remain. */
const UserFilter: React.FC<Props> = ({ options }) => {
	const filters = useSignalValue(aiCostsFiltersSignal);
	const users = React.useMemo(
		() => options?.usersOf(filters.organizationId, filters.facilityId) ?? [],
		[options, filters.organizationId, filters.facilityId],
	);

	const handleChange = React.useCallback((value: number | null) => {
		setAiCostsFilters(aiCostsFiltersSignal.peek().setUser(value));
	}, []);

	return (
		<Dropdown<number>
			name="aiCostsUser"
			label="Utilisateur"
			placeholder="Tous les utilisateurs"
			options={users}
			optionLabel="label"
			optionValue="id"
			loading={options === null}
			showClear
			filter
			value={filters.userId}
			onChange={handleChange}
		/>
	);
};

export default UserFilter;
